import { render, staticRenderFns } from "./EditAlbumName.vue?vue&type=template&id=4295b780&scoped=true&"
import script from "./EditAlbumName.vue?vue&type=script&lang=js&"
export * from "./EditAlbumName.vue?vue&type=script&lang=js&"
import style0 from "./EditAlbumName.vue?vue&type=style&index=0&id=4295b780&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4295b780",
  null
  
)

component.options.__file = "EditAlbumName.vue"
export default component.exports